export class FunidElementsCreator {
    static createNode(tagName, options) {
        const node = document.createElement(tagName);
        if (options === null || options === void 0 ? void 0 : options.className) {
            node.className = options.className;
        }
        if (options === null || options === void 0 ? void 0 : options.attrs) {
            Object.entries(options.attrs).forEach(([key, value]) => {
                node.setAttribute(key, value);
            });
        }
        return document.createElement(tagName);
    }
}
//# sourceMappingURL=funid-elements-creator.js.map